<template> 
 <div v-show="myConfig.visible">
    <DatePicker ref="myControl" v-model="value"  :size="myConfig.size"  :format="myConfig.format"  :placeholder="myConfig.placeholder"  type="datetimerange" clearable  :disabled="myConfig.readOnly" transfer   @on-change="onEnter" @on-enter="onEnter" @on-open-change="onOpenChange" style="width:100%" />
 </div>
</template>
<script>
    import Base from '@/components/base/controlbase.vue';
    export default {
        name: 'daterangebox',
        extends: Base,
        data () {
            return {
                myConfig: {
                    vtype:'datetimerange',
                    format:'yyyy-MM-dd',
                    defaultValue:''
                },
                value:['',''],
                oldValue:['',''],
                svalue: '',
                evalue: '',
                oldSvalue: '',
                oldEvalue: ''
            };
        },
        props:{
            fatherSvalue: {
                type: [String, Date], 
                default: ''
            },
            fatherEvalue: {
                type: [String, Date],
                default: ''
            },
        },
        methods: {
            customInit () {
                if (!this.value) {
                    this.value = ['',''];
                }
                if (this.fatherSvalue) {
                    this.value.splice(0, 1, new Date(this.fatherSvalue));
                }
                if (this.fatherEvalue) {
                    this.value.splice(1, 1, new Date(this.fatherEvalue));
                }
            },
            valueToFatherValue() {
                let para= {};
                para.sname = this.myConfig.sname;
                para.ename = this.myConfig.ename;
                if (this.value[0]) {
                    para.svalue =  this.$Method.formatDate(this.value[0], this.myConfig.format); 
                } else {
                    para.svalue = '';
                }
                if (this.value[1]) {
                    para.evalue =  this.$Method.formatDate(this.value[1], this.myConfig.format); 
                } else {
                    para.evalue = '';
                }
                return para;
            },
            onOpenChange(value) {
                if (this.config.onOpenChange) {
                    this.config.onOpenChange(value);
                }
            },
            onEnter () {
                this.$nextTick(() => {
                    this.setFatherValue();
                });
            },
            setFocus(value) {
                if (value) {
                    this.$refs.myControl.$refs.input.focus();
                    this.$refs.myControl.isFocused = true;
                } else {
                    this.$refs.myControl.$refs.input.blur();
                    this.$refs.myControl.isFocused = false;
                }
            },
            setFatherValueSuccess(para) {
                this.oldValue = this.$Method.copy(this.value);
                this.oldSvalue = para.svalue;
                this.oldEvalue = para.evalue;
                this.$emit('input', para);
            },
            setFatherValueFail() {
                this.$nextTick(() => {
                    this.value = this.$Method.copy(this.oldValue);
                    this.oldSvalue =  this.$Method.formatDate(this.oldValue[0], this.myConfig.format); 
                    this.oldEvalue =  this.$Method.formatDate(this.oldValue[1], this.myConfig.format); 
                });  
            },
        },

        watch: {
            fatherSvalue: {
                handler(newValue) {
                    if (newValue) {
                        newValue = new Date(newValue);
                    }
                    this.value.splice(0, 1, newValue);
                    
                }
            },
            fatherEvalue: {
                handler(newValue) {
                    if (newValue) {
                        newValue = new Date(newValue);
                    }
                    this.value.splice(1, 1, newValue);
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/datebox/daterangebox.vue